import { VuexState, Organization } from '@/common/Organizations';

import axios from 'axios';
import uuid from 'uuid/v4';
import organizationsMock from '../../tests/mocks/organizations.mock';

const state: VuexState = {
     organizations: [],
     organization: undefined,
};

const getters = {
     clientIds(state: VuexState) {
          if (state.organization !== undefined) {
               return state.organization.client_ids;
          }
     },
     users(state: VuexState) {
          if (state.organization !== undefined) {
               return state.organization.users;
          }
     },
};

const mutations = {
     setOrganizations(state: VuexState, payload: Organization[]): void {
          state.organizations = payload;
     },
     addOrganization(state: VuexState, payload: Organization[]): void {
          state.organizations = payload;
     },
     setOrganization(state: VuexState, payload: Organization): void {
          state.organization = payload;
     },
     addClientId(state: VuexState, payload: any): void {
          state.organization.client_ids = payload;
     },
     updateInvites(state: VuexState, payload: any): void {
          state.organization.invites = payload;
     },
};

const actions = {
     clearData({ commit }: any): void {
          commit('setOrganizations', []);
          commit('setOrganization', undefined);
     },
     async createOrganization({ commit }: any, payload: Organization): Promise<string> {
          // Do Axios call to add data
          try {
               const createOrganization = await axios({
                    method: 'POST',
                    url: process.env.VUE_APP_API_STAFF_URI + '/staff/organizations',
                    data: payload,
               });

               console.log(createOrganization);

               // commit('setOrganizations', createOrganization.data);

               return createOrganization.data.org_id;
          } catch (e) {
               throw new Error(e.response.data.error);
          }
     },
     async updateOrganization({ commit }: any, payload: Organization): Promise<string> {
          // Do Axios call to add data
          try {
               const updateOrganization = await axios({
                    method: 'PUT',
                    url: process.env.VUE_APP_API_STAFF_URI + '/staff/organizations',
                    data: payload,
               });

               console.log(updateOrganization);

               return updateOrganization.data.org_id;
          } catch (e) {
               throw new Error(e.response.data.error);
          }
     },
     async getOrganizations({ commit }: any): Promise<boolean> {
          try {
               const getOrganizations = await axios({
                    method: 'GET',
                    url: process.env.VUE_APP_API_STAFF_URI + '/staff/organizations',
               });

               commit('setOrganizations', getOrganizations.data);

               return true;
          } catch (e) {
               throw new Error('There was an error fetching organizations');
          }
     },
     async getOrganization({ commit }: any, orgId: string): Promise<void> {
          try {
               const getOrganization = await axios({
                    method: 'GET',
                    url: process.env.VUE_APP_API_STAFF_URI + '/staff/organizations?org_id=' + orgId,
               });

               commit('setOrganization', getOrganization.data);
          } catch (e) {
               throw new Error('There was an error fetching the organization');
          }
     },
     async updateOrgAdmin(
          { commit }: any,
          {
               orgId,
               sub,
               status,
               client_ids,
               brand,
               users,
          }: {
               orgId: string;
               sub: string;
               status: string;
               client_ids: any;
               brand: string;
               users: any;
          },
     ): Promise<void> {
          try {
               const getOrganization = await axios({
                    method: 'GET',
                    url:
                         process.env.VUE_APP_API_STAFF_URI +
                         '/staff/organizations?org_id=' +
                         orgId +
                         '&sub=' +
                         sub +
                         '&status=' +
                         status +
                         '&client_ids=' +
                         client_ids +
                         '&brand=' +
                         brand +
                         '&users=' +
                         users,
               });

               commit('setOrganization', getOrganization.data);
          } catch (e) {
               console.log(e);
               throw new Error('There was an error updating the organizations admins');
          }
     },
     async addClientId(
          { commit }: any,
          payload: {
               client_id: string;
          },
     ): Promise<string> {
          // Do Axios call to add data
          try {
               const addClientId = await axios({
                    method: 'POST',
                    url: process.env.VUE_APP_API_STAFF_URI + '/staff/organizations/client_ids',
                    data: payload,
               });

               console.log(addClientId);

               if (addClientId.data.success === undefined) {
                    commit('addClientId', addClientId.data);
                    return 'Client Id has been added to the agency.';
               }

               return addClientId.data.msg;
          } catch (e) {
               throw new Error(e.response.data.error);
          }
     },
     async inviteUser({ commit }: any, payload: any): Promise<any> {
          try {
               const inviteUser = await axios({
                    method: 'POST',
                    url: process.env.VUE_APP_API_STAFF_URI + '/staff/organizations/invite',
                    data: payload,
               });

               console.log(inviteUser.data);

               commit('updateInvites', inviteUser.data.invites);

               return inviteUser.data;
          } catch (e) {
               console.log(e.response);
               throw new Error('There was an error fetching the organization');
          }
     },
     async refreshClientIds(
          { commit }: any,
          payload: {
               orgId: string;
          },
     ): Promise<void> {
          // Do Axios call to add data
          try {
               const addClientId = await axios({
                    method: 'POST',
                    url: process.env.VUE_APP_API_STAFF_URI + '/staff/organizations/client_id/refresh/',
                    data: {
                         org_id: payload,
                    },
               });

               console.log(addClientId);

               //    if (addClientId.data.success === undefined) {
               //         commit('addClientId', addClientId.data);
               //         return 'Client Id has been added to the agency.';
               //    }

               //    return addClientId.data.msg;
          } catch (e) {
               console.log(e.response);
               // throw new Error(e.response.data.error);
          }
     },
};

export { state, getters, mutations, actions };
